<template>
  <div id="app" class="main">
		<lwzx-header ref="head"></lwzx-header>
		<router-view></router-view>
    <div class="printer-box" @click="handleShowPrinter">
      <img src="./assets/online/ico_print.png">
    </div>
  </div>
</template>

<script>

import { mapActions, mapMutations } from 'vuex'
import LwzxHeader from '@/components/Header'
export default {
  name: 'app',
  components: {
    LwzxHeader
  },
  methods: {
    ...mapMutations({
      updateKey: 'updateKey'
    }),
    handleShowPrinter () {
      this.updateKey({
        key: 'printerVisible',
        value: true
      })
    },
    ...mapActions({
      getConfigInfoData: 'getConfigInfoData'
    })
  },
  mounted () {
  },
  created () {
    this.getConfigInfoData()
  }
}
</script>

<style lang="scss">
.printer-box {
  position: fixed;
  right: px2rem(12);
  bottom: px2rem(150);
  width: px2rem(172);
  height: px2rem(140);
  z-index: 7;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
